var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgramming(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09229 20.5C8.09229 17.6997 8.09228 16.2996 8.63726 15.2301C9.11661 14.2892 9.88151 13.5243 10.8223 13.045C11.8919 12.5 13.292 12.5 16.0923 12.5H45.0923C47.8925 12.5 49.2928 12.5 50.3623 13.045C51.303 13.5243 52.068 14.2892 52.5473 15.2301C53.0923 16.2996 53.0923 17.6997 53.0923 20.5V39.5C53.0923 42.3003 53.0923 43.7005 52.5473 44.77C52.068 45.7108 51.303 46.4757 50.3623 46.955C49.2928 47.5 47.8925 47.5 45.0923 47.5H16.0923C13.292 47.5 11.8919 47.5 10.8223 46.955C9.88151 46.4757 9.11661 45.7108 8.63726 44.77C8.09228 43.7005 8.09229 42.3003 8.09229 39.5V20.5Z",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5923 22.5L18.0923 30L25.5923 37.5M35.5923 22.5L43.0923 30L35.5923 37.5",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramming);
export default __webpack_public_path__ + "static/media/programming.47a2f61a58defb9961cbb8ae754fecf3.svg";
export { ForwardRef as ReactComponent };